<template>
  <div class="card p-4 shadow-sm rounded-3 info-patient-card">
    <!-- En-tête -->
    <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
      <h4 class="fw-bold mb-0 text-primary">
        <i class="bi bi-person-lines-fill me-2"></i> Informations personnelles
      </h4>

      <button class="btn btn-outline-primary btn-sm" v-if="$store.getters.hasPermission('IMPRESSION_FICHE_PATIENT')" @click="imprimerFicheMedicale">
        <i class="bi bi-printer"></i>
      </button>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Chargement des informations...</p>
    </div>

    <!-- Informations -->
    <div v-else-if="patient" class="row g-4">

      <!-- Nom + Prénom -->
      <div class="col-md-4"><p><strong>Nom :</strong> {{ patient.nom }}</p></div>
      <div class="col-md-4"><p><strong>Prénom :</strong> {{ patient.prenom }}</p></div>

      <!-- Sexe + Naissance -->
      <div class="col-md-4"><p><strong>Sexe :</strong> {{ patient.genre || "Non renseigné" }}</p></div>
      <div class="col-md-4"><p><strong>Date de naissance :</strong> {{ formatDate(patient.dateNaissance) }}</p></div>
      <div class="col-md-4"><p><strong>Âge :</strong> {{ calculAge(patient.dateNaissance) }} ans</p></div>

      <!-- Téléphone + Email + Adresse -->
      <div class="col-md-4"><p><strong>Téléphone :</strong> {{ patient.telephone || "—" }}</p></div>
      <div class="col-md-4"><p><strong>Email :</strong> {{ patient.email || "—" }}</p></div>
      <div class="col-md-4"><p><strong>Adresse :</strong> {{ patient.adresse || "—" }}</p></div>

      <!-- NUMÉRO DOSSIER -->
      <div class="col-md-4"><p><strong>N° Dossier :</strong> {{ patient.numeroDossier || "Non attribué" }}</p></div>

      <!-- Groupe sanguin -->
      <div class="col-md-4"><p><strong>Groupe Sanguin :</strong> {{ patient.groupeSanguin || "—" }}</p></div>

      <!-- Maladies particulières -->
      <div class="col-md-4">
        <p><strong>Antécedents médicaux :</strong> {{ patient.antecedentsMedicaux || "Aucune" }}</p>
      </div>

      <!-- Allergies -->
      <div class="col-md-4">
        <p><strong>Allergies :</strong> {{ patient.allergies || "Aucune" }}</p>
      </div>

      <!-- Profession -->
      <div class="col-md-4">
        <p><strong>Profession :</strong> {{ patient.profession || "—" }}</p>
      </div>

    

      <!-- Informations Assurance -->
      <div class="col-md-12 mt-3">
        <h5 class="text-primary fw-bold border-bottom pb-1">Informations assurance</h5>
      </div>

      <div class="col-md-4"><p><strong>Nom assurance :</strong> {{ patient.assuranceNom || "—" }}</p></div>
      <div class="col-md-4"><p><strong>N° assurance :</strong> {{ patient.assuranceNumero || "—" }}</p></div>
      <div class="col-md-4"><p><strong>Contact assureur :</strong> {{ patient.assureurContact || "—" }}</p></div>

    </div>

    <div v-else class="text-center text-muted py-4">
      <i class="bi bi-info-circle fs-3 d-block mb-2"></i>
      <p>Aucune information trouvée pour ce patient.</p>
    </div>
  </div>
</template>


<script>
import api from "@/api";

export default {
  props: ["patientId"],
  data() {
    return {
      patient: null,
      isLoading: true,
      configClinique: {},
    };
  },

  created() {
    this.fetchPatient();
    this.fetchConfigClinique();
  },

  computed: {
    CurrentUser() {
      return this.$store.getters.user;
    },
  },

  methods: {
    async fetchPatient() {
      this.isLoading = true;
      try {
        const res = await api.getItem("patients", this.patientId);
        this.patient = res.data;
      } catch (error) {
        console.error("Erreur patient :", error);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchConfigClinique() {
      try {
        const res = await api.getItems("configurations");
        this.configClinique = res.data.data?.[0] || {};
      } catch (err) {
        console.error("Erreur config clinique", err);
      }
    },

    formatDate(date) {
      if (!date) return "—";
      return new Date(date).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    calculAge(date) {
      if (!date) return "—";
      const now = new Date();
      const birth = new Date(date);

      let age = now.getFullYear() - birth.getFullYear();
      const m = now.getMonth() - birth.getMonth();

      if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
        age--;
      }

      return age;
    },

imprimerFicheMedicale() {
  if (!this.patient) return;

  const patient = this.patient;
  const config = this.configClinique || {};

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const reference = `PAT-${patient.id}-${new Date().getFullYear()}`;
  const printWindow = window.open("", "_blank");

  const htmlContent = `
    <html>
      <head>
        <title>Fiche ${patient.nom || ""} ${patient.prenom || ""} </title>
        <style>
          @page { size: A4; margin: 2cm; }
          body {
            font-family: "Times New Roman", serif;
            color: #000; font-size: 14px; line-height: 1.6;
            margin: 0; padding: 0;
          }

          header {
            position: fixed; 
            top: 0;
            left: 0; 
            right: 0; height: 90px;
            display: flex; justify-content: space-between; align-items: center;
            border-bottom: 2px solid #0056b3; padding: 10px 2cm;
          }

          footer {
            position: fixed; bottom: 0; left: 0; right: 0; height: 20px;
            border-top: 2px solid #0056b3; padding: 10px 2cm;
            font-size: 13px; display: flex; justify-content: space-between;
          }

          .content {
            margin-top: 120px;
            margin-bottom: 95px;
            padding: 0 1cm;
          }

          header img {
            width: 80px; height: 80px; object-fit: contain;
          }

          .info h2 { margin: 0; color: #0056b3; font-size: 20px; }
          .info p { margin: 2px 0; font-size: 13px; }

          h3 {
            text-align: center; color: #0056b3; text-decoration: underline;
            margin-top: 10px;
          }

          table {
            width: 100%; border-collapse: collapse; margin-top: 10px;
          }
          
          td {
            padding: 8px; border-bottom: 1px solid #ccc;
          }

          td.title {
            font-weight: bold; width: 25%;
          }

          @media print { header, footer { position: fixed; } }
        </style>
      </head>

<body>
  <header>
    <div style="display:flex; align-items:center;">
      ${logoUrl ? `<img src="${logoUrl}" alt="Logo Clinique">` : ""}
      <div class="info" style="margin-left:15px;">
        <h2>${config.nom || "Clinique Médicale"}</h2>
        <p>${config.adresse || ""}</p>
        <p>Tél : ${config.telephone || ""}</p>
        ${config.email ? `<p>Email : ${config.email}</p>` : ""}
      </div>
    </div>

    <div style="text-align:right;">
      <p><strong>N° :</strong> ${reference}</p>
      <p><strong>Date :</strong> ${new Date().toLocaleDateString()}</p>
    </div>
  </header>

  <div class="content">

    <h3>FICHE DU PATIENT</h3>

    <!-- SECTION INFORMATIONS PERSONNELLES -->
    <section>
      <h4 style="color:#2a7ae2; border-bottom:2px solid #2a7ae2; padding-bottom:5px;">
        Informations personnelles
      </h4>

      <table>
        <tr>
          <td class="title">Nom</td><td>${patient.nom || ""}</td>
          <td class="title">Prénom</td><td>${patient.prenom || ""}</td>
        </tr>

        <tr>
          <td class="title">Sexe</td><td>${patient.genre || "—"}</td>
          <td class="title">Âge</td><td>${this.calculAge(patient.dateNaissance)} ans</td>
        </tr>

        <tr>
          <td class="title">Date de naissance</td><td>${this.formatDate(patient.dateNaissance)}</td>
          <td class="title">N° Dossier</td><td>${patient.numeroDossier || "—"}</td>
        </tr>

        <tr>
          <td class="title">Adresse</td><td>${patient.adresse || "—"}</td>
          <td class="title">Téléphone</td><td>${patient.telephone || "—"}</td>
        </tr>

        <tr>
          <td class="title">Email</td>
          <td colspan="3">${patient.email || "—"}</td>
        </tr>

        <tr>
          <td class="title">Profession</td>
          <td>${patient.profession || "—"}</td>
           <td class="title">Personne à contacter (en cas d’urgence)</td>
          <td>${patient.contactUrgenceTelephone || "—"}</td>

        </tr>

        <tr>
          <td class="title">Groupe sanguin</td>
          <td>${patient.groupeSanguin || "—"}</td>
          <td class="title">Allergies</td>
          <td>${patient.allergies || "—"}</td>
        </tr>

        <tr>
          <td class="title">Entecedents Médicaux</td>
          <td colspan="3">${patient.antecedentsMedicaux || "—"}</td>
        </tr>
      </table>
    </section>

    <!-- SECTION ASSURANCE -->
    <section style="margin-top:25px;">
      <h4 style="color:#2a7ae2; border-bottom:2px solid #2a7ae2; padding-bottom:5px;">
        Informations assurance
      </h4>

      <table>
        <tr>
          <td class="title">Nom assurance</td>
          <td>${patient.assuranceNom || "—"}</td>

          <td class="title">N° assurance</td>
          <td>${patient.assuranceNumero || "—"}</td>
        </tr>

        <tr>
          <td class="title">Contact assureur</td>
          <td colspan="3">${patient.assureurContact || "—"}</td>
        </tr>
      </table>
    </section>

    <!-- SIGNATURE -->
    <section style="margin-top:40px; text-align:right;">
      <p>Fait à ${config.ville || ""}, le ${new Date().toLocaleDateString()}</p>
      <p><strong>${this.CurrentUser.typeUser}</strong></p>
      <p>${this.CurrentUser.nom} ${this.CurrentUser.prenom}</p>
      <p>Signature & cachet</p>
    </section>

  </div>

  <footer>
    <p>${config.nom || ""} - ${config.adresse || ""}</p>
    <p>© ${new Date().getFullYear()} Tous droits réservés</p>
  </footer>

</body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
}



  },
};
</script>

<style scoped>
.info-patient-card {
  background: #fff;
  border-radius: 12px;
}

p {
  margin-bottom: 0;
  font-size: 0.95rem;
}

h5 {
  margin-top: 15px;
}

@media print {
  button {
    display: none !important;
  }
}
</style>

